// pages

import Index from "../pages/main/Index";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";

const routes = [
  { path: "/", component: <Index /> },
  { path: "/term-and-conditions", component: <TermsAndConditions /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
];

export { routes };
